import { ReactChild, useState } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Node, useReactFlow } from "@xyflow/react";

import { EItemType, IItemComparison, IItemOption } from "../../../SimuladorInteligente/interfaces";
import { IDefaultInputInstruction, IDefaultMessage } from "../../interfaces";

import NodeFormDrawer from "../NodeFormDrawer";

interface IProps {
  node: Node;
  title: string;
  IconComponent: ReactChild;
  defaultMessages: IDefaultMessage[];
  defaultInputInstructions: IDefaultInputInstruction[];
}

export default function NodeHeader({
  node,
  title,
  IconComponent,
  defaultInputInstructions,
  defaultMessages,
}: IProps) {
  const [isEditing, setIsEditing] = useState(false);

  const {
    deleteElements,
    updateNode,
    getEdges,
    setNodes
  } = useReactFlow();

  const handleDelete = () => {
    deleteElements({ nodes: [{ id: node.id }] })
  };

  const handleEdit = () => {
    setNodes((prevState) => prevState.map((n) => ({
      ...n,
      selected: n.id === node.id ? true : false,
    })))
    setIsEditing(true);
  };

  const handleSubmitEditing = (node: Node) => {
    if (node.type === EItemType.OPTIONS) {
      const edges = getEdges();
      const options = node.data.options as IItemOption[];

      const edgesToDelete = edges.filter((e) => e.source === node.id && !options.find((opt) => opt.text === e.sourceHandle));

      deleteElements({ edges: edgesToDelete });
    }

    if (node.type === EItemType.COMPARISON) {
      const edges = getEdges();
      const comparisons = node.data.comparisons as IItemComparison[];

      const edgesToDelete = edges.filter((e) => e.source === node.id && !comparisons.find((comp) => comp.id === e.sourceHandle || (e.sourceHandle?.startsWith('comparison') && e.sourceHandle?.endsWith('default'))));

      deleteElements({ edges: edgesToDelete });
    }

    updateNode(node.id, node);
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          borderBottom: "1px solid #cdcdcd",
          padding: "4px 8px",
          marginBottom: 8,
        }}
      >
        {IconComponent}

        <label htmlFor="text">{title}</label>

        <EditOutlined onClick={handleEdit} />
        <DeleteOutlined onClick={handleDelete} />
      </div>

      {
        isEditing && (
          <NodeFormDrawer
            visible
            onClose={() => setIsEditing(false)}
            onSubmit={handleSubmitEditing}
            nodeToEdit={node}
            defaultInputInstructions={defaultInputInstructions}
            defaultMessages={defaultMessages}
          />
        )
      }
    </>
  )
}
